import { useDrag } from 'react-dnd'
import React from 'react'

import { useDndActions, useDndState } from './DndHandler'

const Draggable = ({ item, type, useMoveCursor, hideOnDrag, children }) => {
  const { disabled } = useDndState()
  const { setDraggingType, setDraggingReference } = useDndActions()

  const [{ opacity, display }, dragRef] = useDrag({
    item: { type, ...item },
    begin: monitor => {
      // TODO: To fix react dnd bug used setTimeout
      setTimeout(() => {
        setDraggingType(type)
        setDraggingReference(item.reference || item.id)
      }, 0)
    },
    end: (item, monitor) => {
      setDraggingType(false)
      setDraggingReference(undefined)
    },
    collect: monitor => {
      const isDragging = monitor.isDragging()
      return {
        opacity: isDragging ? 0.8 : 1,
        display: isDragging ? 'none' : 'block'
      }
    }
  })

  if (disabled) return children

  return (
    <div ref={dragRef} style={{ opacity, cursor: useMoveCursor && 'move', display: hideOnDrag && display }}>
      {children}
    </div>
  )
}

export default Draggable
